import { ReportModes, ProductTypes } from '../Models/Constants';

/**
 * Maps a report mode to a product.
 * e.g. SPOTLIGHT => REPORTING, FRANCHISE => MULTI
 */
export const getProductByReportMode = (reportMode: ReportModes): ProductTypes => {
    switch (reportMode) {
        case ReportModes.Spotlight: {
            return ProductTypes.Reporting;
        }
        case ReportModes.Forecast: {
            return ProductTypes.Forecasting;
        }
        case ReportModes.Dashboard: {
            return ProductTypes.Dashboard;
        }
        case ReportModes.Franchise: {
            return ProductTypes.Multi;
        }
        case ReportModes.Sustain: {
            return ProductTypes.Sustain;
        }
    }
};
